exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".div-iframe{height:100%;background-color:#fff;left:0px;top:0px;right:0px;bottom:0px;z-index:10;visibility:hidden}.iframe-full{width:100% !important;height:100%;border-style:none}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/widget/components/driveItemFullScreen/DriveItemFullScreen.scss
// module id = 521
// module chunks = 0 1